<script>
  import Common from '../js/common.js';

  export let lang = undefined;

  const i18n = {
    loginWithGoogle: {
      cs: 'Přihlásit se přes Google',
      en: 'Login with Google',
    },
  };
</script>

<a href='{Common.BACKEND_URL}/connect/google' class='login-with-google'>
  <div class='login-with-google-logo'>
    <img class='login-with-google-logo-image' src='img/static/logo/google.svg' alt='Google logo'/>
  </div>

  <div class='login-with-google-box'>
    <div class='login-with-google-box-text'>
      <span class='material-icons'> login </span> {i18n.loginWithGoogle[lang]}
    </div>
  </div>
</a>

<style>
  .login-with-google {
    position: relative;

    display: flex;

    width: 100%;
    height: 40px;

    border-radius: var(--radius-lg);

    text-decoration: none;

    color: var(--white);
    background: #4285F4;

    user-select: none;
  }

  .login-with-google-logo {
    position: absolute;
    top: 1px;
    left: 1px;

    width: 20px;
    height: 20px;

    padding: 9px;

    border-radius: calc(var(--radius-lg) - 1px) 0px 0px calc(var(--radius-lg) - 1px);

    background: var(--white);
  }

  .login-with-google-logo-image {
    width: 100%;
    height: 100%;
  }

  .login-with-google-box {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;

    border-radius: var(--radius-lg);

    z-index: 1;

    transition: background-color 0.25s ease-in-out;
  }

  .login-with-google:hover .login-with-google-box {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .login-with-google:active .login-with-google-box {
    background-color: rgba(0, 0, 0, 0.2);
  }

  :global(body.dark) .login-with-google {
    color: var(--grey-3);
    background: #3A75D7;
  }

  :global(body.dark) .login-with-google-logo {
    background: var(--grey-3);
  }

  :global(body.dark) .login-with-google-logo-image {
    filter: brightness(88%);
  }

  :global(body.dark) .login-with-google:hover .login-with-google-box {
    background-color: rgba(255, 255, 255, 0.1);
  }

  :global(body.dark) .login-with-google:active .login-with-google-box {
    background-color: rgba(255, 255, 255, 0.2);
  }
</style>
